/* Tiroir « façon Rue des Peignoirs » (2026-11-02) — la carte « 2e article à −20 % ».
   1. Changement de variante : le prix affiché suit l'option choisie. Le prix remisé n'est montré que si la remise
      est vraie : panier d'un seul article, sans code (data-offre) ET variante au plus aussi chère que l'article du
      panier (data-ref, en centimes) — Shopify remise le MOINS CHER des deux.
   2. « + » : ajout SANS quitter le tiroir, même mécanique que product-form.js du thème : un CartLinesUpdateEvent
      porteur d'une promesse, /cart/add.js avec le rendu des sections <cart-items-component>, puis la promesse est
      résolue → component-cart-items.js re-rend le tiroir (morph) et la pastille du panier suit.
   Écouteurs délégués sur document : ils survivent au remplacement du tiroir. Sans JS, le formulaire part vers
   /cart/add (et un menu « Choisir la taille » obligatoire bloque l'envoi par la validation native). */
import { CartLinesUpdateEvent } from '@shopify/events';

if (!window.__rdpDuo) {
  window.__rdpDuo = true;

  const prix = (carte, opt) => {
    const el = carte.querySelector('[data-rdp-prix]');
    if (!el || !opt || !opt.dataset.p) return;
    const p = Number(opt.dataset.p), ref = Number(carte.dataset.ref || 0), offre = carte.dataset.offre === 'true';
    const t = carte.dataset;
    if (offre && p <= ref) {
      el.innerHTML = `<b>${opt.dataset.rm}</b> <s>${opt.dataset.pm}</s> <span class="rdp-duo__badge">${t.badge}</span>`;
    } else {
      el.innerHTML = `<b>${opt.dataset.pm}</b>` + (offre ? ` <span class="rdp-duo__note">${t.note}</span>` : '');
    }
  };

  document.addEventListener('change', (e) => {
    const s = e.target;
    if (!(s instanceof HTMLSelectElement) || !s.matches('[data-rdp-sel]')) return;
    const carte = s.closest('[data-rdp-duo]');
    s.classList.remove('is-a-choisir');
    const msg = carte && carte.querySelector('.rdp-duo__msg'); if (msg) msg.hidden = true;
    if (carte) prix(carte, s.selectedOptions[0]);
  });

  // Taille pas encore choisie : on le dit dans la carte (avant la bulle native du navigateur).
  document.addEventListener('click', (e) => {
    const b = e.target instanceof Element && e.target.closest('[data-rdp-duo] .rdp-duo__plus');
    if (!b) return;
    const carte = b.closest('[data-rdp-duo]'), s = carte.querySelector('[data-rdp-sel]');
    if (!s || s.value) return;
    e.preventDefault();
    s.classList.add('is-a-choisir'); s.focus();
    const msg = carte.querySelector('.rdp-duo__msg'); if (msg) { msg.textContent = carte.dataset.choisir || ''; msg.hidden = false; }
  });

  document.addEventListener('submit', async (e) => {
    const f = e.target;
    if (!(f instanceof HTMLFormElement) || !f.matches('form[data-rdp-duo-form]')) return;
    e.preventDefault();
    const carte = f.closest('[data-rdp-duo]');
    const msg = carte && carte.querySelector('.rdp-duo__msg');
    const id = new FormData(f).get('id');
    if (!id) {
      const s = f.querySelector('[data-rdp-sel]');
      if (s) { s.classList.add('is-a-choisir'); s.focus(); }
      if (msg) { msg.textContent = carte.dataset.choisir || ''; msg.hidden = false; }
      return;
    }
    const b = f.querySelector('button[type="submit"]');
    if (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); }
    const ids = [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean);
    const differe = CartLinesUpdateEvent.createPromise();
    f.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: String(id), quantity: 1 }], promise: differe.promise }));
    try {
      const url = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
      const r = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: ids.join(','), sections_url: location.pathname }) });
      const rep = await r.json();
      if (!r.ok || rep.status) throw new Error(rep.description || rep.message || 'ajout impossible');
      const panier = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      differe.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(panier),
        detail: { items: panier.items, source: 'rdp-duo', sourceId: 'rdp-duo', itemCount: 1, sections: rep.sections, didError: false } });
    } catch (err) {
      differe.reject(err);
      if (b) { b.disabled = false; b.removeAttribute('aria-busy'); }
      if (msg) { msg.textContent = (carte && carte.dataset.erreur) || String(err.message || err); msg.hidden = false; }
    }
  });
}
